export function sortCountries(countries:any, t:Function) {
  if (!countries) return []
  let editableCountries = JSON.parse(JSON.stringify(countries))
  return editableCountries.sort((country1:any, country2:any) => {
    // 'Other' should always be the last element
    if (country1.alpha3 === 'OTHER') return 1 
    if (country2.alpha3 === 'OTHER') return -1 
    const name1 = t(`country-${country1.alpha3}`)
    const name2 = t(`country-${country2.alpha3}`)
    if (name1 < name2) return -1
    if (name1 > name2) return 1
    return 0
  })
}
